import { Injectable } from '@angular/core';

import { CartItem } from '../store/cart/cart.state';

export interface PartialErrorProduct {
  name: string;
  quantity: number;
}

export interface OrderPartialErrorData {
  failedProducts: PartialErrorProduct[];
  backendErrorMessage: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrderPartialErrorService {
  private data: OrderPartialErrorData | null = null;

  setPartialError(failedCartItems: CartItem[], backendError: unknown): void {
    const failedProducts: PartialErrorProduct[] = failedCartItems.map(item => ({
      name: item.product?.name ?? 'Produto',
      quantity: item.quantity,
    }));
    const backendErrorMessage = this.extractErrorMessage(backendError);
    this.data = { failedProducts, backendErrorMessage };
  }

  getPartialError(): OrderPartialErrorData | null {
    return this.data;
  }

  consumeAndClear(): OrderPartialErrorData | null {
    const data = this.data;
    this.data = null;
    return data;
  }

  hasPartialError(): boolean {
    return this.data != null && this.data.failedProducts.length > 0;
  }

  private extractErrorMessage(error: unknown): string {
    if (error == null) return '';
    const err = error as { error?: { message?: string; msg?: string }; message?: string };
    if (err?.error?.message) return String(err.error.message);
    if (err?.error?.msg) return String(err.error.msg);
    if (err?.message) return String(err.message);
    return typeof error === 'string' ? error : '';
  }
}
